import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { gt } from '@ember/object/computed';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { SYNC_STATUSES } from 'cio/utils/ad-audiences';
import { tracked } from '@glimmer/tracking';
import { importSync } from '@embroider/macros';

export default class SettingsController extends Controller {
  @service apiErrors;
  @service audienceCredentials;
  @service router;

  queryParams = [
    {
      _confirmReconnection: 'isReconnecting',
    },
  ];

  SYNC_STATUSES = SYNC_STATUSES;
  cheerImage = new URL('cio/assets/images/cheer.png', import.meta.url).toString();

  @tracked _countConfirmation = null;

  @computed('model.audiences')
  get audiencesByStatus() {
    let { audiences } = this.model;

    return Object.values(SYNC_STATUSES)
      .map((status) => {
        return {
          ...status,
          audiences: audiences.filter((audience) => audience.get('status.id') === status.id),
        };
      })
      .filter((status) => status.audiences.length > 0);
  }

  @computed('model.audiences.length', '_countConfirmation')
  get _removeAdNetworkDisabled() {
    let { length: count } = this.model.audiences;
    return count > 0 && parseInt(this._countConfirmation) !== count;
  }

  get settingsComponent() {
    let module = importSync(`../../../../../components/audiences-settings/${this.model.type.replace('_', '-')}`);

    return module.default;
  }

  @gt('model.audiences.length', 0) hasAudiences;

  _confirmDisconnection = false;
  _confirmReconnection = null; // query param: null or "true", initialized to null to avoid adding it to the URL when using RouterService.transitionTo

  _disconnectTask = task(
    {
      drop: true,
    },
    async () => {
      let {
        model: { credential },
      } = this;

      try {
        await credential.destroyRecord();
        this.router.transitionTo('integrations');
      } catch (err) {
        this.apiErrors.report(err);
        throw err;
      } finally {
        this.set('_countConfirmation', null);
      }
    },
  );

  _reconnectTask = task(
    {
      drop: true,
    },
    async () => {
      let {
        model: { type, credential },
      } = this;

      await this.audienceCredentials.setupProviderTask.perform(type, credential);
    },
  );

  setDefaults() {
    this.set('_confirmDisconnection', false);
  }

  @action
  hideReconnectionConfirmation() {
    this._reconnectTask.cancelAll({ resetState: true });
    this.set('_confirmReconnection', null);
  }

  @action
  cancelDisconnect() {
    this.setProperties({
      _countConfirmation: null,
      _confirmDisconnection: false,
    });
  }
}
